import { useEffect, useRef, useState } from "react";
import { Heart, Search } from "react-feather";
import { FaSearch } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { getDropdownData } from "../../api/keyvalue";
import {
  getDynamicTemplateById,
  getDynamicTemplateList,
  getFavDynamicTemplateCount,
  makeFavoriteDynamicTemplate,
} from "../../api/templateApi";
import Grid from "../../components/Grid";
import LoadingSpinner from "../../components/LoadingSpinner";
import Tab from "../../components/Tab";
import Button from "../../components/input/Button";
import Dropdown from "../../components/input/Dropdown";
import Input from "../../components/input/Input";
import SideDrawer from "../../components/input/SideDrawer";
import DynamicTemplateCreation from "../../components/master/dynamicTemplate/DynamicTemplateCreation";
import ButtonRenderer from "../../components/renderer/ButtonRenderer";
import {
  ActiveCellStyle,
  ResizableScrollingTextRenderer,
  StatusCellStyle,
} from "../../components/renderer/StyleRenderer";
import { FORMS, MODULES } from "../../const";
import useFirstAndLastAuthorizedTab from "../../hooks/useFirstAndLastAuthorizedTab";
import { templateActions } from "../../store/master/template-slice";
import { toast } from "react-toastify";
import { initSidebarFavorites } from "../../components/sidebar/sidebarData.init";

const DynamicTemplate = () => {
  const { firstViableTab } = useFirstAndLastAuthorizedTab({
    module: MODULES.Fleet,
    section: FORMS.TEMPLATE,
  });
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [managementTypeOptions, setManagementTypeOptions] = useState([]);
  const [statusOpt, setStatusOpt] = useState([]);
  const [activeOpt, setActiveOpt] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [searchClicked, setSearchClicked] = useState(false);
  const [isSearchResultsPending, setIsSearchResultsPending] = useState(false);
  const gridRef = useRef(null);

  const [tab, setTab] = useState(1);
  const [activeAccordion1, handleAccordionClick1] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const [templateName, setTemplateName] = useState("");
  const [status, setStatus] = useState(2);
  const [active, setActive] = useState(1);
  const [category, setCategory] = useState("");
  const [managementType, setManagementType] = useState("");
  const [dyhCode, setDyhCode] = useState("");

  const [selectedId, setSelectedId] = useState("");
  const [selectedCode, setSelectedCode] = useState("");

  const [reset, setReset] = useState(false);
  const [addMode, setAddMode] = useState(true);
  const [makingFavId, setMakingFavId] = useState(null); // dyhId or null
  const [favourite, setFavourite] = useState(false);
  const [updateNeeded, setUpdateNeeded] = useState(false);

  useEffect(() => {
    (async () => {
      setIsLoading(true);

      const categoryOpt = await getDropdownData("inspection_category");
      setCategoryOptions(categoryOpt);

      const managementTypeOpt = await getDropdownData("inspection_type");
      setManagementTypeOptions(managementTypeOpt);

      const status = await getDropdownData("status");
      setStatusOpt(status);

      const active = await getDropdownData("active");
      setActiveOpt(active);

      setIsLoading(false);
    })();
  }, []);

  const getSearchResults = async () => {
    try {
      setSearchClicked(true);
      setIsSearchResultsPending(true);
      const data = {
        dyhCompany: 1,
        dyhCategory: category,
        dyhInspectionType: managementType,
        dyhTemplate: templateName,
        dyhStatus: status,
        dyhActive: active,
        dyhCode: dyhCode,
      };

      const response = await getDynamicTemplateList(data);
      console.log("Dynamic template response", response);

      // response.sort((a, b) => b.dyhId - a.dyhId);
      setSearchResults(response);
      setIsSearchResultsPending(false);
    } catch (e) {
      console.error(e);
    } finally {
      setIsSearchResultsPending(false);
      setSearchClicked(true);
      handleAccordionClick1(false);
    }
    setSearchClicked(true);
    handleAccordionClick1(false);
  };

  useEffect(() => {
    if (updateNeeded) {
      getSearchResults();
      setUpdateNeeded(false);
    }
  }, [updateNeeded]);

  const resetAll = () => {
    setDyhCode("");
    setTemplateName("");
    setStatus(2);
    setActive(1);
    setCategory("");
    setManagementType("");
    setSearchResults([]);
    setSearchClicked(false);
  };

  const handleDrawerOpen = () => {
    setIsDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setSelectedId("");
    setSelectedCode("");
    setEditMode(false);
    dispatch(templateActions.clearFieldList());
    setIsDrawerOpen(false);
    setReset(true);
    setAddMode(true);
  };

  console.log(searchResults);

  const makeFavorite = async (data, currentValue) => {
    try {
      if (currentValue === false) {
        const favTempCount = await getFavDynamicTemplateCount();
        if (favTempCount && favTempCount >= 10) {
          toast.error("You can not add more than 10 favorite templates.", {
            autoClose: 5000,
            containerId: "Main",
          });
          return;
        }
      }

      setMakingFavId(data.dyhId);
      await makeFavoriteDynamicTemplate(data);

      await initSidebarFavorites();
      getSearchResults();
    } finally {
      setMakingFavId(null);
    }
  };

  return (
    <div>
      <div
        className="ui tabular attached"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div className="ui tabular menu top attached">
          <Tab
            Icon={FaSearch}
            onClick={() => {
              setTab(1);
            }}
            active={tab === 1}
            label="Search Template"
          />
        </div>
        <Button
          template="drawerOpen"
          disabled={firstViableTab === -1}
          onClick={handleDrawerOpen}
          authenticated={true}
          form={FORMS.TEMPLATE.DYNAMIC_TEM.form}
          module={MODULES.Fleet}
          editMode={false}
        />
      </div>

      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 1 ? "block" : "none", width: "100%" }}
      >
        <div
          class="ui styled accordion"
          style={{ width: "100%", marginBottom: "10px" }}
        >
          <div
            className={`title ${activeAccordion1 ? "active" : ""}`}
            onClick={() => handleAccordionClick1(!activeAccordion1)}
          >
            <div>
              Click here to expand search
              <Search size={14} style={{ marginLeft: "10px" }} />
              <i class="dropdown icon"></i>
            </div>
          </div>
          <div className={`content ${activeAccordion1 ? "active" : ""}`}>
            {isLoading ? (
              <LoadingSpinner />
            ) : (
              <form className="ui form">
                <h4 className="ui dividing header">Information</h4>

                <div className="three fields">
                  <Input
                    label="Template Code"
                    type="text"
                    name="dyhCode"
                    value={dyhCode}
                    onChange={(e) => setDyhCode(e.target.value)}
                  />
                  <Dropdown
                    clearable
                    search={true}
                    options={categoryOptions}
                    placeholder="Category"
                    label="Category"
                    value={category}
                    onChange={(e, data) => {
                      setCategory(data.value);
                    }}
                  />

                  <Dropdown
                    clearable
                    search={true}
                    options={managementTypeOptions}
                    placeholder={"Management Type"}
                    label="Management Type"
                    value={managementType}
                    onChange={(e, data) => {
                      setManagementType(data.value);
                    }}
                  />
                </div>
                <div className="three fields">
                  <Input
                    label="Template Name"
                    type="text"
                    name="templateName"
                    value={templateName}
                    onChange={(e) => setTemplateName(e.target.value)}
                  />
                  <Dropdown
                    label="Status"
                    placeholder="Select Status"
                    options={statusOpt}
                    value={status}
                    onChange={(e, data) => setStatus(data.value)}
                  />
                  <Dropdown
                    label="Active"
                    placeholder="Select Active"
                    options={activeOpt}
                    value={active}
                    onChange={(e, data) => setActive(data.value)}
                  />
                </div>

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <div className="field" style={{ width: "100%" }}>
                    <Button template="search" onClick={getSearchResults} />
                    <Button template="searchReset" onClick={resetAll} />
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>

        {searchClicked && (
          <>
            {isSearchResultsPending ? (
              <LoadingSpinner />
            ) : (
              <Grid
                isLoading={isSearchResultsPending}
                autoHeight={true}
                // rowHeight={50}
                searchable={true}
                config={[
                  {
                    headerName: "Template Code",
                    field: "dyhCode",
                    width: 180,
                    cellRenderer: ResizableScrollingTextRenderer,
                    pinned: "left",
                    cellStyle: { backgroundColor: "#fff9c4" },
                  },
                  {
                    headerName: "Template Name",
                    field: "dyhTemplate",
                    width: 180,
                    cellRenderer: ResizableScrollingTextRenderer,
                    cellStyle: { backgroundColor: "#DDFFE7" },
                  },
                  {
                    headerName: "Category",
                    field: "dyhCategoryValue",
                    width: 180,
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Management Type",
                    field: "dyhInspectionTypeValue",
                    width: 180,
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Description",
                    field: "dyhDescription",
                    width: 180,
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Next Inspection",
                    field: "dyhNextInspection",
                    width: 180,
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "UOM",
                    field: "dyhNextUomValue",
                    width: 180,
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Status",
                    field: "dyhStatusValue",
                    cellRenderer: StatusCellStyle,
                  },
                  {
                    headerName: "Active",
                    field: "dyhActiveValue",
                    cellRenderer: ActiveCellStyle,
                  },
                  {
                    headerName: "Favorite",
                    field: "favorite",
                    cellRenderer: ButtonRenderer,
                    tooltipValueGetter: (params) => {
                      return "Click to make favorite";
                    },
                    cellRendererParams: (params) => {
                      console.log(params);
                      return {
                        clickHandler: () => {
                          makeFavorite(
                            {
                              dyhId: params?.data?.dyhId,
                              user: user.username,
                            },
                            params?.data?.dyhFavourite,
                          );
                        },
                        Icon: Heart,
                        iconColor:
                          params?.data?.dyhFavourite === true ? "red" : "black",
                        disabled: false,
                        filled: true,
                        className: "ui button",
                        isLoading: makingFavId === params?.data?.dyhId,
                        iconSize: 20,
                      };
                    },
                    pinned: "right",
                    width: 100,
                    minWidth: 100,
                  },
                ]}
                content={searchResults}
                ref={gridRef}
                onCellDoubleClicked={async (props) => {
                  setIsDrawerOpen(true);
                  setEditMode(true);
                  setSelectedId(props.data.dyhId);
                  setSelectedCode(props.data.dyhCode);
                  setFavourite(props.data.dyhFavourite);

                  // Fetch the selected template details
                  const dataRow = await getDynamicTemplateById(
                    props.data.dyhId,
                  );
                  console.log("Editing dataRow", dataRow);
                  // Map selected dynamic fields properly
                  const updatedFields = dataRow.dynamicFields?.map((field) => ({
                    ...field,
                    dyfMultiSelectDynamicColumn: field.dynamicColumns.map(
                      (col) => col.ddcField,
                    ),
                  }));

                  dispatch(templateActions.clearFieldList());
                  updatedFields.forEach((field) =>
                    dispatch(templateActions.addToFieldList(field)),
                  );
                }}
              />
            )}
          </>
        )}
      </div>

      <SideDrawer
        open={isDrawerOpen}
        handleDrawerClose={handleDrawerClose}
        head={
          <div className="drawer-header">
            {!editMode && <h3>Dynamic Template Creation</h3>}

            {editMode && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <div>{favourite ? <Heart size={25} color={"red"} /> : ""}</div>

                <div>
                  <h3>Update Template Temp code: {selectedCode}</h3>
                </div>
              </div>
            )}
          </div>
        }
        body={
          <DynamicTemplateCreation
            editMode={editMode}
            setEditMode={setEditMode}
            selectedId={selectedId}
            selectedCode={selectedCode}
            handleDrawerClose={handleDrawerClose}
            reset={reset}
            setReset={setReset}
            addMode={addMode}
            setAddMode={setAddMode}
            setUpdateNeeded={setUpdateNeeded}
          />
        }
        style={{ width: "90vw" }}
      />
    </div>
  );
};

export default DynamicTemplate;
